//
import { Record } from 'immutable';

export const mkTransferBalance = Record({
  id: undefined,
  identityId: undefined,
  balance: undefined,
});
